define('helper-url-parseModified',['exports'], function (exports) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    exports.default = function (str) {
        var parse = function parse(str) {
            return str.replace(/[^\d]/g, '');
        };

        if (!str || typeof str !== 'string') {
            str = new Date().toJSON();
        }

        var res = parse(str);

        return res ? res : parse(new Date().toJSON());
    };
});
